import script from "./TlsaRecords.vue?vue&type=script&setup=true&lang=ts"
export * from "./TlsaRecords.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__